export default function License() {
  return (
    <section id="license" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(0,217,255,0.03) 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }}></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#8b5cf6]/10 border border-[#8b5cf6]/30 px-4 py-2 rounded-full mb-6">
            <i className="ri-creative-commons-line text-[#8b5cf6]"></i>
            <span className="text-[#8b5cf6] text-sm font-medium">License</span>
          </div>
          <h2 className="text-5xl font-bold text-white mb-6 font-['Space_Grotesk']">
            Open Source & Free
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Bellibutton is released under the MIT License - free to use, modify, and distribute
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border border-white/10 rounded-3xl p-10">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-16 h-16 bg-[#00d9ff]/10 rounded-2xl flex items-center justify-center">
                <i className="ri-open-source-line text-[#00d9ff] text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">MIT License</h3>
                <p className="text-gray-500">Simple and permissive</p>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-green-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-green-500"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Commercial Use</h4>
                  <p className="text-gray-400 text-sm">Use Bellibutton in commercial projects without restrictions</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-green-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-green-500"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Modification</h4>
                  <p className="text-gray-400 text-sm">Modify the source code to fit your specific needs</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-green-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-green-500"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Distribution</h4>
                  <p className="text-gray-400 text-sm">Distribute original or modified versions freely</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-green-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-green-500"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">Private Use</h4>
                  <p className="text-gray-400 text-sm">Use and modify privately without sharing changes</p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-white/10">
              <a
                href="#"
                className="inline-flex items-center gap-2 text-[#00d9ff] hover:text-[#00b8d4] transition-colors cursor-pointer"
              >
                <i className="ri-file-text-line"></i>
                <span className="font-medium">Read Full License</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border border-white/10 rounded-2xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <i className="ri-github-fill text-white text-3xl"></i>
                <div>
                  <h3 className="text-xl font-bold text-white">Contribute on GitHub</h3>
                  <p className="text-gray-500 text-sm">Join our community of contributors</p>
                </div>
              </div>
              <p className="text-gray-400 mb-6">
                Bellibutton is open source and welcomes contributions from developers worldwide. Whether it's bug fixes, new features, or documentation improvements, we'd love your help!
              </p>
              <a
                href="https://github.com/yeswayjosue/bellibutton"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/5 border border-white/10 text-white font-semibold rounded-xl hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-git-branch-line"></i>
                <span>View on GitHub</span>
              </a>
            </div>

            <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border border-white/10 rounded-2xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <i className="ri-team-line text-[#8b5cf6] text-3xl"></i>
                <div>
                  <h3 className="text-xl font-bold text-white">Community</h3>
                  <p className="text-gray-500 text-sm">Connect with other developers</p>
                </div>
              </div>
              <p className="text-gray-400 mb-6">
                Join our Discord server to get help, share ideas, and collaborate with other Bellibutton users and contributors.
              </p>
              <div className="flex gap-3">
                <a
                  href="#"
                  className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#5865F2] text-white font-semibold rounded-xl hover:bg-[#4752C4] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-discord-line"></i>
                  <span>Discord</span>
                </a>
                <a
                  href="#"
                  className="flex-1 inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#1DA1F2] text-white font-semibold rounded-xl hover:bg-[#1A8CD8] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-twitter-x-line"></i>
                  <span>Twitter</span>
                </a>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#00d9ff]/10 to-[#8b5cf6]/10 border border-[#00d9ff]/30 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-white mb-3">Support the Project</h3>
              <p className="text-gray-400 mb-6">
                If you find Bellibutton useful, consider starring the repository on GitHub or sponsoring the project to help with ongoing development.
              </p>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#00d9ff] to-[#00b8d4] text-black font-semibold rounded-xl hover:shadow-lg hover:shadow-[#00d9ff]/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-heart-line"></i>
                <span>Sponsor Project</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
